import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const HEAD_LENGTH = 12

// `length` (px) only changes the line: the head and stroke stay the same size
const ArrowIcon = ({ length = 40, ...props }: IconProps & { length?: number }) => (
  <ChakraIcon viewBox={`0 0 ${length} 14`} w={`${length}px`} h="14px" {...props}>
    <path d={`M0 7h${length - HEAD_LENGTH + 2}`} stroke="currentColor" strokeWidth={2.5} />
    <path fill="currentColor" d={`M${length - HEAD_LENGTH} 0.5 ${length} 7 ${length - HEAD_LENGTH} 13.5z`} />
  </ChakraIcon>
)

export default ArrowIcon
